import emptySplitApi from '..';

export const staticPageApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    staticPage: build.query({
      query: (params) => ({
        url: `/static-pages`,
        method: 'GET',
        params,
      }),
      transformResponse: (response) => response[0] || {},
    }),
  }),
});

export const { useStaticPageQuery } = staticPageApi;
